import { theme } from '@ahmdigital/ui';

import getIsServer from './get-is-server';

const breakpoints = {
  lg: Number(theme.media.lg.replace('px', '')),
  md: Number(theme.media.md.replace('px', '')),
  sm: Number(theme.media.sm.replace('px', '')),
  xs: Number(theme.media.xs.replace('px', '')),
};

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg';

function isMobile() {
  const isServer = getIsServer();
  return !isServer && window.outerWidth <= breakpoints.sm;
}

function isTabletOrMobile() {
  const isServer = getIsServer();
  return !isServer && window.outerWidth <= breakpoints.md;
}

function isLargeTabletOrMobile() {
  const isServer = getIsServer();
  return !isServer && window.outerWidth <= breakpoints.lg;
}

function getBreakpoint(): Breakpoint {
  const isServer = getIsServer();

  if (isServer) return 'lg';

  const width = window.outerWidth;

  if (width < breakpoints.sm) return 'xs'; // < 768px
  if (width < breakpoints.md) return 'sm'; // 768–1023px
  if (width < breakpoints.lg) return 'md'; // 1024–1279px
  return 'lg'; // 1280px+
}

export default {
  getBreakpoint,
  isLargeTabletOrMobile,
  isMobile,
  isTabletOrMobile,
};
